import { Getters } from 'vuex-smart-module';
import AuthState from './state';

export default class AuthGetters extends Getters<AuthState> {
}
